import axios from 'axios'
import { getCSRFToken } from './security'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/api'
const TIMEOUT = import.meta.env.VITE_API_TIMEOUT || 30000

const apiClient = axios.create({
  baseURL: API_URL,
  timeout: TIMEOUT,
})

// Add CSRF token to all requests and handle FormData
apiClient.interceptors.request.use((config) => {
  const csrfToken = getCSRFToken()
  if (csrfToken) {
    config.headers['X-CSRF-Token'] = csrfToken
  }
  // Don't set Content-Type for FormData - let axios/browser handle it
  if (!(config.data instanceof FormData)) {
    config.headers['Content-Type'] = 'application/json'
  }
  return config
})

// Handle errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized - could redirect to login
      console.error('Unauthorized access')
    }
    return Promise.reject(error)
  }
)

export const contactService = {
  submit: (data) => apiClient.post('/contact', data),
}

export const appointmentService = {
  create: (data) => apiClient.post('/appointments', data),
  getAvailable: () => apiClient.get('/appointments/available'),
}

export const paymentService = {
  createPaymentIntent: (data) => apiClient.post('/payments/intent', data),
  confirmPayment: (data) => apiClient.post('/payments/confirm', data),
}

export default apiClient
